import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import Login from "./views/Login";
import About from "./views/About";
import Signup from "./views/Signup";
import EventAdmin from "./views/EventAdmin";
import Presentation from "./views/Presentation";
import Slide from "./views/Slide";
import DefaultDrawer from "@/components/drawer";
import EventDrawer from "@/components/drawer/event";
import SlideEditorDrawer from "@/components/drawer/slideeditor";
import ListSlides from "@/components/event/ListSlides";
import SlideEditor from "@/components/event/slides/SlideEditor";
import SingleSlide from "./views/SingleSlide";
import SlideOverview from "@/components/event/slides/SlideOverview";
import firebase from "firebase";
import store from "./store";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      components: {
        default: Home,
        sidebar: DefaultDrawer
      },
      meta: {
        authentication: true
      }
    },
    {
      path: "/login",
      name: "login",
      component: Login
    },          
    {
      path: "/signup",
      name: "signup",
      component: Signup
    },          
    {
      path: "/event/:eventid",
      name: "event",
      components: {
        default: EventAdmin,
        sidebar: EventDrawer
      },
      children: [
        {
          path: "",
          component : About
        },
        {
          path: "screens",
          component : Presentation,
          children:[
            {
              path: "",
              component: ListSlides
            },
            {
              path: "new",
              components: {
                dialog: Presentation
              }
            }                    
          ]
        }        
      ]

    },
    {
      path: "/slide/:slideid/:slide",
      components:{ 
        banana: SingleSlide
      }
    },
    {
      path: "/editor/:eventid/slide/:slideid",
      components: {
        default: Slide,
        sidebar: SlideEditorDrawer
      },
      meta: {
        authentication: true
      } ,
      children:[
        {
          path: "",
          components:{ 
            default: SlideOverview
          }
        },
        {
          path: ":slide",
          components:{ 
            default: SlideEditor
          }
        }        
      ]

    }    ,        

    {
      path: "/about",
      name: "about",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/About.vue")
    }
  ]
});

router.beforeEach(async (to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.authentication);
  let currentUser = store.state.application.user;
  if (!currentUser && requiresAuth) {
    next("/login");
  } else {
    next();
  }
});

export default router;
